import {EntityViewProperties} from "./EntityViewProperties";

export const AllEntitiesviews = `
    query requestGeometries {
        allEntitiesviews {
        nodes {
            stAsgeojson
            ${EntityViewProperties}
        }
    }
}`
